import { render, staticRenderFns } from "./VehicleManagePanel.vue?vue&type=template&id=5a667964&scoped=true"
import script from "./VehicleManagePanel.vue?vue&type=script&lang=js"
export * from "./VehicleManagePanel.vue?vue&type=script&lang=js"
import style0 from "./VehicleManagePanel.vue?vue&type=style&index=0&id=5a667964&prod&lang=scss&scoped=true"
import style1 from "./VehicleManagePanel.vue?vue&type=style&index=1&id=5a667964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a667964",
  null
  
)

export default component.exports